module.exports ={
  title: ['安全设置','Security Settings'],
  overseasAccount: ['海外收款账户','Overseas Account'],
  lastLoginTime: ['上次登录网站时间：','Last Website Login Time：'],
  boundPhone: ['绑定手机号','Bound mobile phone'],
  unboundPhone: ['解绑手机号','Unbound mobile phone'],
  reset: ['重置','Reset'],
  setting: ['设置','Settings'],
  bound: ['绑定','Bound'],
  unbound: ['未绑定','Unbound'],
  phone: ['手机号','Mobile phone'],
  phone_label: ['手机号：','Mobile phone：'],
  email_label: ['邮箱：','Email：'],
  noGetCode: ['此号无法收取验证码','This account cannot receive verif. code'],
  code_label: ['验证码：','Verif. code：'],
  code: ['验证码','Verif. code'],
  loginPwd_label: ['当前登录密码：','Current login pwd.：'],
  loginPwd_placeholder: ['输入当前登录密码','enter current login pwd.'],
  newLoginPwd_label: ['新登录密码：','New login pwd.：'],
  newLoginPwd_placeholder: ['输入新登录密码','enter new login pwd.'],
  confirmLoginPwd_label: ['确认新登录密码：','confirm new login pwd.：'],
  confirmLoginPwd_placeholder: ['再次输入新登录密码','enter new login pwd.again'],
  materials_label: ['证明材料：','Supporting document：'],
  materials_tips: ['图片格式为：.jpg和.png；图片大小不得超过2M；','Image format: .jpg&.png; image size ≤ 2M'],
  materials_name: ['盖章的商户变更表','Merchant change form with official seal'],
  oldPayPwd_label: ['旧支付密码：','Old payment pwd：'],
  oldPayPwd_placeholder: ['请输入旧支付密码','enter old payment pwd'],
  forgetPwd: ['忘记密码？','Forget pwd'],
  newPayPwd_label: ['新支付密码：','New payment pwd：'],
  confirmPayPwd_label: ['确认新支付密码：','Confirm payment pwd：'],
  payPwd_check: ['支付密码必须是6位数字','Pwd code must be 6-dligit numbers'],
  payPwd_placeholder: ['请输入支付密码','enter payment pwd'],
  phone_placeholder: ['输入手机号','enter mobile phone'],
  boundEmail_placeholder: ['输入要绑定的邮箱地址','enter the email address to be bound'],
  code_placeholder: ['输入收到的验证码','enter verif. code received'],
  emailCode_label: ['邮箱验证码：','Email verif. code：'],
  emailCode_placeholder: ['输入邮箱收到的验证码','enter email verif. Code received'],
  successTip1: ['新密码已更换成功，请使用手机号和新的登录密码重新登录，系统将','The new pwd. has been changed successfully. Please log in again with your mobile phone and new login pwd.'],
  successTip2: ['后自动退出，如果系统无法自动退出，请点击下方“重新登录”。','The system will auto-logout shortly. If the system fails to auto-logout, please click "log in again" below.'],
  nextStep: ['下一步','Next step'],
  sure: ['确定','Confirm'],
  resetLogin: ['重新登录','Login in again'],
  tips: ['温馨提示','Tips'],
  payPwd_tips1: ['支付密码未设置','Payment pwd not set'],
  payPwd_tips2: ['为了保障您的账户资金安全，请先设置支付密码','To ensure the security of your accouont funds, please set the payment pwd. first'],
  payPwd_tips3: ['请前往','Please go to'],
  payPwd_tips4: ['用户设置-->安全设置','User Settings-->Security Settings'],
  payPwd_tips5: ['进行支付密码设置；或点击下方','set the payment pwd,or click the buttom below'],
  payPwd_tips6: ['去设置','to set'],
  payPwd_tips7: ['按钮','button'],
  confirmPayPwd_placeholder: ['请确认支付密码','confirm the payment pwd'],
  payPwd_checkInfoError: ['两次输入的支付密码不一致','The payment pwd entered twice are inconsistent'],
  confirmPwd_placeholder: ['请确认密码','confirm the pwd'],
  confirmPwd_checkInfoError: ['两次输入的密码不一致','The pwd entered twice are inconsistent'],
  email_placeholder: ['请输入邮箱','enter the email address'],
  email_checkInfoError: ['输入的邮箱格式不正确','The entered email address format is incorrect'],
  changePhone: ['更换手机号','Change Mobile phone'],
  loginPwd: ['登录密码','Login pwd'],
  editPwd: ['修改登录密码','Change login pwd'],
  loginPwd_desc: ['登录系统时需要输入的密码','The pwd required when logging in to the system'],
  payPwd: ['支付密码','Payment pwd'],
  payPwd_desc: ['在账户资金变动，修改账户信息时需要输入的密码','The pwd required when there is a change in account funds or when modifying account info'],
  email: ['邮箱','Email'],
  email_desc: ['用于接收易生推送关键信息及密钥',"Used to Receive Easypay's Pushed Key Info & Secret Key"],
  code_desc: ['请输入验证码','enter verif. code'],
  emailCode_desc: ['请输入邮箱验证码','enter email verif. code'],
  payPwdSettingSuccess: ['支付密码设置成功～','Payment pwd is set successfully～'],
  payPwdEditSuccess: ['支付密码修改成功～','Payment pwd is change successfully～'],
  unboundEmailSuccess: ['邮箱解绑成功～','Email unbound successfully～'],
  boundEmailSuccess: ['邮箱绑定成功～','Email bound successfully～'],
  unboundPhoneSuccess: ['手机解绑成功～','Mobile phone unbound successfully～'],
  boundPhoneSuccess: ['手机绑定成功～','Mobile phone bound successfully～'],
  codeSendSuccess: ['邮箱验证码发送成功～','Email verif. code is sent successfully～'],
  correctEmail_placeholder: ['请填写正确的邮箱～','fill in the correct email address～'],
  checkPhone_placeholder: ['请检查手机号','check the mobile phone'],
  editPayPwd: ['修改支付密码','Modify payment pwd'],
  boundEmail: ['绑定邮箱','Bound email'],
  unboundEmail: ['解绑邮箱','Unbound email'],
  null: ['暂无数据','N/A'],
  overseas: {
    title: ['新增收款账户','Add Payee Account'],
    accountList: ['账户列表','Account List'],
    accountType: ['账号类型','Account type'],
    accountStatus: ['账号状态','Account status'],
    auditReason: ['状态说明','Status descripition'],
    accountFee: ['开户费','Account opening fee'],
    payAccountFee: ['开户费扣款状态','Account opening fee deduction status'],
    debited: ['已扣','deducted'],
    noDebit: ['未扣','no deducted'],
    accountNo: ['账号','Account No.'],
    accountName: ['账户名称','Account name'],
    countryName: ['账号所属国家/地区','Country/region of account ownership'],
    bankName: ['收款行名称','Beneficiary`s bank name'],
    bankBic: ['收款行SWIFT BIC','Beneficiary`s bank SWIFT BIC'],
    bankAddress: ['收款行地址','Beneficiary`s bank address'],
    transferNote: ['转账备注','Transfer remarks'],
    operation: ['操作','Operation'],
    view: ['查看','View'],
    uploadAgain: ['补传','Upload again'],
    downloadUploadAgainFile: ['补传资料下载','download supplementary documents'],
    edit: ['修改','modify'],
    localVirtualAccount: ['本地虚拟户','Local VA'],
    accountCountry: ['VA国家/地区','VA country/region'],
    accountCountry_placeholder: ['请选择VA国家/地区','select VA country/region'],
    supportCurrency_label: ['支持币种：','Supported currency：'],
    localAccountName: ['境内收款账户','Domestic receiving account'],
    localAccountName_placeholder: ['请选择境内收款账户','select domestic receiving account'],
    localBankAddress: ['境内开户行地址','Address of domestic depository bank'],
    select: ['请选择','select'],
    detailAddress: ['详细地址','Detailed address'],
    provideService: ['提供的产品和服务','Products and services provided'],
    productionStatus: ['生产情况','Production status'],
    other: ['其他','Other'],
    sourcesFunding: ['资金来源','Source of funds'],
    purposeOfPay: ['付款目的','Purpose of payment'],
    purposeOfPay_message: ['您付款给客户的钱款的性质','nature of funds you pay to customers'],
    tradingVolume: ['每月交易量','Monthly trans volume'],
    pcs: ['笔','PCS'],
    transAmount: ['每月交易额','Monthly trans amount'],
    currency: ['币种','Currency'],
    proofAddressFile_label: ['法人地址证明文件：','Legal representative`s addr proof doc.：'],
    proofAddressFile_tips1: ['png、jpg文件','png, jpg files'],
    proofAddressFile_tips2: ['地址证明文件说明：','Addr proof doc. description：'],
    proofAddressFile_tips3: ['可接受的文件类型：显示姓名和地址 3 个月内的信用卡账单、银行账单、水电煤气单、移动电 话账单、宽带账单、居住证、房产证、租房合同','acceptable doc. types: Credit card stmts., bank stmts., utility bills (water, electricity, gas), mobile phone bills, broadband bills, residence permits, house property certs., rental contracts issued within 3 months (showing name & address)'],
    proofAddressFile_label2: ['股东地址证明文件： （占股超过25%的股东）','Shareholder`s addr. proof doc. (shareholders with >25% ownership)'],
    add: ['新 增','Add'],
    addAccount: ['新增收款账户','Add new receiving account'],
    edit: ['修 改','Modify'],
    editAccount: ['修改收款账户','Modify receiving account'],
    cancel: ['取 消','cancel'],
    uploadAgainFile: ['补传资料','Supplemental doc. upload'],
    uploadAgainFile_label: ['补传资料：','Supplemental doc. upload：'],
    prompt: ['提示','Prompt'],
    close: ['关 闭','Close'],
    tips1: ['出现该提示，说明您的账户当前开通的跨境业务可能遇到如下问题暂时无法使用该功能，需要优先处理：','This prompt indicates the cross-border service activated for your acct. may have the following issues, making this function temporarily unavailable. Prioritize resolution: '],
    tips2: ['1、尚未通过银行备案；','1. Bank filing not yet completed;'],
    tips3: ['2、已通过银行备案，但需要您下载备案登记表并盖章回传；','2. Bank filing completed, but need to download the filing reg. form, affix an official seal, and return it;'],
    tips4: ['请您对照如上问题按如下步骤进行处理：','Please follow the steps below to address the above issues：'],
    tips5: ['问题1：','Question 1'],
    tips6: ['新开通跨境业务，该备案过程最快需要1-3个工作日，可通过业务','For newly activated cross-border services, the filing process takes 1-3 working days at the fastest.'],
    tips7: ['“业务权限浏览”','"Business permission browse"'],
    tips8: ['下的','below'],
    tips9: ['“查看银行备案信息”','"View bank filing info"'],
    tips10: ['查看最终进展，请您耐心等待；','check the final progress,please wait patiently;'],
    tips11: ['问题2：','Question 2'],
    tips12: ['点击菜单','click the menu'],
    tips13: ['下跨境人民币付款/收款下的','cross-border RMB payment/receipt'],
    tips14: ['在操作栏先点击','click the operation bar firstly'],
    tips15: ['“下载备案表”','"Download filing form"'],
    tips16: ['，核对下载文件信息后，请盖章并扫描或拍照清晰照片后，以jpg、png格式文件回传。','verify downloaded file info.,please affix an official seal, then scan or take a clear photo, and return it as a JPG or PNG file'],
    checkErrorInfo_placeholder: ['请检查错误信息','check error info'],
    detailAddress_placeholder: ['请填写详细地址','fill in detailed address'],
    provideService_placeholder: ['请填写提供的产品和服务','fill in products and services provided'],
    productionStatus_placeholder: ['请选择生产情况','select production status'],
    other_placeholder: ['请填写其他','select other'],
    sourcesFunding_placeholder: ['请选择资金来源','select source of funds'],
    purposeOfPay_placeholder: ['请填写付款目的','fill in the purpose of payment'],
    tradingVolume_placeholder: ['请填写每月交易量','fill in monthly trans volume'],
    transAmount_placeholder: ['请填写每月交易额','fill in monthly trans amount'],
    currency_placeholder: ['请选择币种','select currency'],
    checkPicUpload_placeholder: ['请检查图片是否上传','check if the image is uploaded'],
    currencyIsNull: ['币种为null','currency is null'],
    transAmount_checkErrorInfo: ['每月交易额最多两位小数','monthly trans. amt. (max. 2 decimal places)'],
    viewAccount: ['查看账户','View account'],
    uploadFile: ['请上传文件！','upload file！'],
  }
}